import { EntTypeAnimal } from "./typeAnimal";

export class EntAnimalBreed {
  id: number = 0; 
  nameRu: string = "";
  alias: string = "";
  nameKy: string = "";
  animalTypeId: number | null = null
  animalType: EntTypeAnimal | null = null
}
